/**
 * SeverityBadge — one canonical severity chip used across the feature pages.
 *
 * Replaces the per-page SEV_BADGE pills so the colour language is identical
 * everywhere: critical=rose, high=amber, medium=cyan, low=emerald, info=blue.
 */
import { clsx } from 'clsx'
import { sevBadge } from '../lib/badges'

export default function SeverityBadge({
  severity, label, className, width,
}: {
  severity: string | null | undefined
  /** Override the visible text (defaults to the severity string). */
  label?: string
  className?: string
  /** Optional fixed-width util class (e.g. 'w-16') so a column of badges aligns. */
  width?: string
}) {
  const sev = (severity || 'medium').toLowerCase()
  return (
    <span className={clsx(
      'text-[10px] px-2 py-0.5 rounded border text-center inline-block',
      sevBadge(sev), width, className,
    )}>
      {label ?? sev}
    </span>
  )
}
